<template>
    <footer>
        <a class="link" href="https://github.com/artyom-sklyarov" target="_blank">
            github
        </a>
        <router-link class="link" to="/posts">
            posts
        </router-link>
        <a class="link letter" href="mailto:hi@artyom.io?subject=a%20humble%20request">
            email
        </a>
        <a class="link" href="https://discord.com/users/240850877433380865" target="_blank">
            discord
        </a>
    </footer>
</template>

<style lang="scss" scoped>
footer {
    grid-area: footer;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 28px;
    padding: 12px 0 0;
    border-top: 1px solid var(--border-color);

    a {
        font-weight: var(--fw-normal);
        font-size: var(--fsz-normal);
        text-decoration: none;
    }

    .link {
        color: var(--color-secondary);
        transition: color 0.2s ease;
        &:hover {
            color: var(--color-primary);
        }
    }

}

@media screen and (max-width: 900px) {
    footer {
        padding: 16px 0;
        gap: 16px;
    }
}
</style>
